import { SHOW_ERROR, DISMISS_ERROR } from '../actionTypes';

export const showErrorAction = ({
  title, message, devDetail, devSource, onPress = () => null, ...rest
}) => ({
  type: SHOW_ERROR,
  payload: {
    user: {
      title,
      message,
    },
    developer: {
      detail: devDetail,
      internal: {
        ...rest,
        message: rest.message,
      },
      source: devSource,
    },
    onPress,
  },
});

export const dismissErrorAction = () => ({
  type: DISMISS_ERROR,
});
